import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PageHeader.module.css';

const PageHeader = ({ 
  title, 
  description,
  breadcrumbs = []
}) => {
  return (
    <div>
      {breadcrumbs.length > 0 && (
        <nav className={styles.nav} aria-label="breadcrumb">
          <ol className={styles.breadcrumb}>
            {breadcrumbs.map((item, index) => (
              <li 
                key={index} 
                className={`${styles.breadcrumbItem} ${index === breadcrumbs.length - 1 ? styles.breadcrumbItemActive : ''}`}
              >
                {index === breadcrumbs.length - 1 ? (
                  <span>{item.text}</span>
                ) : (
                  <Link to={item.href}>{item.text}</Link>
                )}
              </li>
            ))}
          </ol>
        </nav>
      )}
      <div className={styles.header}>
        <h1 className={styles.title}>{title}</h1>
        {description && (
          <p className={styles.description}>{description}</p>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
